import React from 'react';
import { Menu } from 'primereact/menu';
const SideNav = ({ items, className = "body-static-height" }) => {
    return (React.createElement("div", { className: className },
        React.createElement(Menu, { model: items, style: { width: '100%' }, className: "pl-2" })));
};
export default SideNav;
